import { type Static, Type } from '@sinclair/typebox';

export const AttributeSchema = Type.Object({
  _id: Type.String(),
  subtype: Type.Union([
    Type.Literal('Accreditation'),
    Type.Literal('Allergy_Compliance'),
    Type.Literal('Component'),
    Type.Literal('Filter'),
    Type.Literal('Other'),
  ]),
  unit: Type.Union([Type.String(), Type.Null()]),
  value: Type.Union([Type.String(), Type.Number(), Type.Array(Type.String()), Type.Array(Type.Number()), Type.Null()]),
});
export type AttributeDTO = Static<typeof AttributeSchema>;
